export const CHECKOUT_DISABLED_REASON = {
  ORGANIZATION_USER: "ORGANIZATION_USER",
  ORGANIZATION_STUDENT: "ORGANIZATION_STUDENT",
} as const;

export type CheckoutDisabledReason = keyof typeof CHECKOUT_DISABLED_REASON;

export const CHECKOUT_DISABLED_CONTENT = {
  [CHECKOUT_DISABLED_REASON.ORGANIZATION_USER]: {
    header:
      "Vi tilbyr for øyeblikket ikke netthandel for skoler, dette kommer snart.",
    body: "Du er logget inn med FEIDE og kan derfor ikke handle i nettbutikken enn så lenge. Logg ut for å handle som privatkunde.",
  },
  [CHECKOUT_DISABLED_REASON.ORGANIZATION_STUDENT]: {
    header: "Du kan ikke handle som student",
    body: "For å handle må du logge inn med en personlig konto, eller be organisasjonsadministratoren om å gi deg kjøperettigheter.",
  },
} satisfies Record<CheckoutDisabledReason, { header: string; body: string }>;
